<template>
  <ui-popover>
    <span slot="reference" class="pointer">
      <ui-icon name="icon-earth"></ui-icon>{{ $t("languageSelect") }}
    </span>
    <ul class="lang-selector">
      <li @click="changeLang('en-US')"><a>English</a></li>
      <li @click="changeLang('zh-CN')"><a>简体中文</a></li>
      <li @click="changeLang('zh-HK')"><a>繁体中文</a></li>
    </ul>
  </ui-popover>
</template>
<script>
import { mapGetters } from "vuex";
import api from "../api/index";

export default {
  data() {
    return {};
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("LANG", lang);
      if (this.authInfo) {
        api.updateProfile({ lang: lang });
      }
    }
  },
  computed: {
    ...mapGetters(["authInfo"])
  }
};

</script>
